import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';
import { addMinutes, startOfDay, getUnixTime } from 'date-fns';
import minutesBetweenTimezones from 'garaje/utils/user-location-timezone-offset';

export default Factory.extend({
  email: () => faker.internet.email(),
  name: () => faker.person.fullName(),
  date: () => faker.date.recent(),
  scheduled: true,
  profilePictureUrl: () => 'https://picsum.photos/50/50',

  withUserAndEmployee: trait({
    afterCreate(scheduledEmployee, server) {
      const offset = minutesBetweenTimezones('Atlantic/Reykjavik');
      const location = server.schema.locations.first();
      const user = server.create('user', { fullName: scheduledEmployee.name, email: scheduledEmployee.email });
      const employee = server.create('employee', {
        user,
        locationIds: [location.id],
        name: scheduledEmployee.name,
        email: scheduledEmployee.email,
      });
      scheduledEmployee.update({ user });
      scheduledEmployee.update({ employee });
      const floor = server.schema.floors.first();
      const desk = server.create('desk', { floor, assignedTo: null });
      server.create('reservation', {
        desk,
        location,
        user,
        startTime: getUnixTime(addMinutes(startOfDay(new Date()), offset)),
        endTime: getUnixTime(addMinutes(startOfDay(new Date()), offset + 1439)),
        userEmail: user.email,
      });
    },
  }),
});
